"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var custom_modal_module_scss_1 = __importDefault(require("./custom-modal.module.scss"));

var Modal_1 = __importDefault(require("@material-ui/core/Modal"));

var Backdrop_1 = __importDefault(require("@material-ui/core/Backdrop"));

var Fade_1 = __importDefault(require("@material-ui/core/Fade"));

var Clear_1 = __importDefault(require("@material-ui/icons/Clear"));

var custom_modal_styles_1 = require("./custom-modal.styles");

var MODAL_TIMEOUT_DURATION = 300;

var CustomModal = function CustomModal(_ref) {
  var isOpen = _ref.isOpen,
      handleClose = _ref.handleClose,
      children = _ref.children,
      _ref$needCloseIcon = _ref.needCloseIcon,
      needCloseIcon = _ref$needCloseIcon === void 0 ? false : _ref$needCloseIcon,
      disableBackdropClick = _ref.disableBackdropClick;
  return react_1.default.createElement(Modal_1.default, {
    "aria-labelledby": "custom-modal",
    "aria-describedby": "custom-modal",
    className: custom_modal_module_scss_1.default.modal,
    open: isOpen,
    onClose: handleClose,
    closeAfterTransition: true,
    BackdropComponent: Backdrop_1.default,
    disableBackdropClick: disableBackdropClick,
    BackdropProps: {
      timeout: MODAL_TIMEOUT_DURATION
    }
  }, react_1.default.createElement(Fade_1.default, {
    in: isOpen
  }, react_1.default.createElement(custom_modal_styles_1.StyledPaperDiv, null, needCloseIcon && react_1.default.createElement(Clear_1.default, {
    fontSize: "large",
    className: custom_modal_module_scss_1.default.closeIcon,
    onClick: handleClose
  }), children)));
};

exports.default = CustomModal;